var _path, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconLockWhite = function SvgIconLockWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 172 172",
    width: "52px",
    height: "52px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,172v-172h172v172z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.84615,0c-14.6262,0 -27.26262,6.07272 -35.14423,15.91827c-7.88161,9.84555 -11.16346,22.61118 -11.16346,36.38462v7.23558h19.84615v-7.23558c0,-10.4399 2.58413,-18.65745 6.82212,-23.98077c4.23798,-5.32331 10.0006,-8.47596 19.63942,-8.47596c9.66467,0 15.40144,2.97176 19.63942,8.26923c4.23798,5.29747 6.82212,13.61839 6.82212,24.1875v7.23558h19.84615v-7.23558c0,-13.85096 -3.48858,-26.74579 -11.37019,-36.59135c-7.88161,-9.84555 -20.33714,-15.71154 -34.9375,-15.71154zM59.53846,66.15385c-10.95673,0 -19.84615,8.88942 -19.84615,19.84615v66.15385c0,10.95673 8.88942,19.84615 19.84615,19.84615h92.61538c10.95673,0 19.84615,-8.88942 19.84615,-19.84615v-66.15385c0,-10.95673 -8.88942,-19.84615 -19.84615,-19.84615zM105.84615,99.23077c7.3131,0 13.23077,5.91767 13.23077,13.23077c0,4.88401 -2.66166,9.07031 -6.61538,11.37019v15.09135c0,3.64363 -2.97176,6.61538 -6.61538,6.61538c-3.64363,0 -6.61538,-2.97176 -6.61538,-6.61538v-15.09135c-3.95372,-2.29988 -6.61538,-6.48618 -6.61538,-11.37019c0,-7.3131 5.91767,-13.23077 13.23077,-13.23077z"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLockWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_lock_white.af3f1829.svg";
export { ForwardRef as ReactComponent };